import { render, staticRenderFns } from "./ServerDetails.vue?vue&type=template&id=7c1bfcf1&"
import script from "./ServerDetails.vue?vue&type=script&lang=js&"
export * from "./ServerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports